import { integerToCurrency } from 'loot-core/shared/util';
import { format as monthUtilFormat } from 'loot-core/src/shared/months';

import { useDateFormat } from '../../../hooks/useDateFormat';
import { useNavigate } from '../../../hooks/useNavigate';
import { useResponsive } from '../../../ResponsiveProvider';
import { styles, theme } from '../../../style';
import { Card } from '../../common/Card';
import { Link } from '../../common/Link';
import { Text } from '../../common/Text';
import { Field, Row, Table, TableHeader } from '../../table';
import { DisplayId } from '../../util/DisplayId';

type IDashboardTransactionsProps = {
  transactions: { [key: string]: any }[];
};

const ROW_HEIGHT = 43;

const DashboardTransactions: React.FC<IDashboardTransactionsProps> = ({
  transactions,
}) => {
  const dateFormat = useDateFormat() || 'MM/dd/yyyy';
  const navigate = useNavigate();
  const { isNarrowWidth } = useResponsive();

  const transactionSelectHandler = transactionId => {
    isNarrowWidth && navigate(`/transactions/${transactionId}`);
  };

  function renderTransaction({ item: transaction }) {
    return (
      <Row
        height={ROW_HEIGHT}
        inset={0}
        style={{
          backgroundColor: theme.tableBackground,
          color: theme.tableText,
          ':hover': { backgroundColor: theme.tableRowBackgroundHover },
          ...(isNarrowWidth ? { cursor: 'pointer' } : {}),
        }}
        onClick={() => transactionSelectHandler(transaction.id)}
      >
        <Field width={90} name="date">
          {monthUtilFormat(transaction.date, dateFormat)}
        </Field>
        <Field width="flex" name="account">
          <DisplayId type="accounts" id={transaction.account} />
        </Field>
        <Field width="flex" name="payee" style={{ paddingRight: '8px' }}>
          <DisplayId type="payees" id={transaction.payee} />
        </Field>
        <Field width={100} name="amount">
          <Text
            title="Amount"
            style={{
              color:
                transaction.amount < 0
                  ? theme.errorText
                  : theme.noticeTextLight,
            }}
          >
            {integerToCurrency(transaction.amount)}
          </Text>
        </Field>
      </Row>
    );
  }

  return (
    <Card className="card">
      <div className="header">
        <p style={{ ...styles.mediumText, fontWeight: 700 }}>Transactions</p>
        <Link to="/accounts" variant="internal">
          View more
        </Link>
      </div>
      {transactions.length ? (
        <>
          <TableHeader height={ROW_HEIGHT}>
            <Field width={90}>Date</Field>
            <Field width="flex">Account</Field>
            <Field width="flex" style={{ paddingRight: '8px' }}>
              Payee
            </Field>
            <Field width={100}>Amount</Field>
          </TableHeader>
          <Table
            rowHeight={ROW_HEIGHT}
            backgroundColor="transparent"
            style={{ flex: 1, backgroundColor: 'transparent' }}
            items={transactions as any[]}
            renderItem={renderTransaction}
            allowPopupsEscape={transactions.length < 6}
          />
        </>
      ) : (
        <div className="placeholder-container">
          You don't have any transactions yet
        </div>
      )}
    </Card>
  );
};
export default DashboardTransactions;
